import purchaseReasonTypes from './purchaseReasons';

export default Object.freeze([
  {
    id: purchaseReasonTypes.IntercambioDeCentro,
    value: 'Intercambio de Centro',
  },
  {
    id: purchaseReasonTypes.IntercambioDeEscuela,
    value: 'Intercambio de Escuela',
  },
  {
    id: purchaseReasonTypes.InventarioDeEscuela,
    value: 'Inventario de Escuela',
  },
  { id: purchaseReasonTypes.InventarioDeCentro, value: 'Inventario de Centro' },
]);
